const PRIMARY_COLOR = '#D93B0C';
const SECONDARY_COLOR = '#FF1D89';
const WHITE = '#FFFFFF';
const RED_0 = '#C21C05';
const RED_3 = '#6D1304';
const RED_4 = '#911906';
const GRADIENT_FROM = '#6D1304';
const GRADIENT_TO = '#B51F07';

const lightTheme = {
    primaryColor: PRIMARY_COLOR,
    secondaryColor: SECONDARY_COLOR,
    backgroundColor: WHITE,
    appbarColor: RED_4,
    navbarColor: `linear-gradient(0deg, ${GRADIENT_FROM}, ${GRADIENT_TO})`,
    buttonColor: RED_0,
    buttonHoverColor: RED_3,
}

export default lightTheme;